export const NO_PRINT_PATH_HINT = 'Drucken ist hier nicht möglich: Bitte labcomplete® im Desktop-Client oder über das AIS öffnen.';

/** The bytes behind one of the API's print downloads; throws when the API does not deliver them. */
export const fetchPrintable = async (path: string, accessToken: string | undefined): Promise<ArrayBuffer> => {
  const response = await fetch(`${window._env_.API_URL}${path}`, {
    headers: { authorization: `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`print download answered ${response.status}`);
  }
  return (await response.blob()).arrayBuffer();
};

/** `count` copies of a label in one print request, as the desktop client sends them. */
export const repeatBytes = async (buffer: ArrayBuffer, count: number): Promise<ArrayBuffer> =>
  new Blob(Array.from({ length: count }, () => buffer)).arrayBuffer();
